export const localToday = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};

// Parse calendar dates locally so the first of a month stays in that month.
export const calendarDate = (value) => {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const splitAmount = (value, settlement = false) => {
  const cents = Math.round(Number(value) * 100);
  if (!Number.isFinite(cents) || cents <= 0) return '';
  return ((settlement ? cents : Math.ceil(cents / 2)) / 100).toFixed(2);
};

export const debtLabel = (person, credit) => {
  const other = person === 'Chris' ? 'Gwen' : 'Chris';
  return credit ? `${person} owes ${other}` : `${other} owes ${person}`;
};
